const styles =  {
    fonts: {
      heading: `"Manrope", sans-serif`,
      body: `"Manrope", sans-serif`,
    }
}
export default  styles;